import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  title: {
    marginBottom: 3,
    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    paddingTop: spacing.$1_5,
  },
  wrapper: {
    marginHorizontal: 'auto',
    maxWidth: spacing.$56,
  },
  wrapperDesktop: {
    maxWidth: spacing.$64,
  },
});

export const Wrapper = ({ focusable = true, style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    focusable,
    style: [styles.wrapper, isDesktop && styles.wrapperDesktop, style],
  });
};

export const Title = withTypography({
  textAlign: 'center',
  color: primitive.$bbqBrown,
  fontSize: 'lg',
  variant: 'headerThree',
  focusable: true,
  style: styles.title,
});

export const CancellationPolicyText = withTypography({
  textAlign: 'center',
  color: primitive.$bbqBrown,
});
